export default (condition, component) => condition ? component : null